import React from 'react';
import { SectionHeaderContainer, Title } from './styled';

export const SectionHeader: React.FC<{
  title: string;
  rightBlock?: unknown;
}> = ({ title, rightBlock }) => {
  return (
    <SectionHeaderContainer>
      <Title>{title}</Title>
      {rightBlock && rightBlock}
    </SectionHeaderContainer>
  );
};
